import React, { FunctionComponent, memo } from 'react';
import { Preset, Color, ShadeColor } from '@lux/text';
import { Translate } from '@pegasus/translation';

import { Campaign } from '@shared/types/mylounge';

import * as S from './discount.styles';

interface Props {
    campaign: Campaign;
}

export const Discount: FunctionComponent<Props> = ({ campaign }) => (
    <S.Container>
        {campaign.discount.isSpecial ? (
            <S.SpecialText bold color={Color.dark} preset={Preset.M}>
                <Translate message="campaigns.campaignSpecial" />
            </S.SpecialText>
        ) : (
            <S.RegularContainer>
                <S.RegularText preset={Preset.XS} color={ShadeColor.dark60}>
                    <Translate message="campaigns.upTo" />
                </S.RegularText>
                <S.MaxDiscountText preset={Preset.M} bold color={Color.dark}>
                    {campaign.discount.maxDiscount}%
                </S.MaxDiscountText>
            </S.RegularContainer>
        )}
    </S.Container>
);

export default memo(Discount);
